module.exports = __webpack_public_path__ + "img/banner3.bfaec711.png";